import { Component, OnInit, ElementRef, ViewEncapsulation, forwardRef, Renderer, Injector, Input } from '@angular/core';
import { BaseFormControl, BaseAbstractControl, mohValidators } from 'moh-package';
import { NG_VALUE_ACCESSOR, FormControl, NG_VALIDATORS } from '@angular/forms';

@Component({
  selector: 'moh-worsening-worse-details',
  templateUrl: './worsening-worse-details.component.html',
  styleUrls: ['./worsening-worse-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => WorseningWorseDetailsComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => WorseningWorseDetailsComponent) }]
})
export class WorseningWorseDetailsComponent extends BaseAbstractControl implements OnInit {
  @Input() worseDetailsLabel: string; 
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {

    this.baseAbstractControl = new FormControl('', [mohValidators.maxLength(2000)]);

    super.ngOnInit();
  }

}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/worsening/worsening-worse-details/worsening-worse-details.component.ts